import React from 'react'
import { useWorkListStoreManager } from 'context/HomeStore/Manager/WorkListsProvider/WorkListProvider.manager'
import { AllStatusesDeal } from 'constants/deals'
import { ButtonTab, ButtonTabsContainer } from 'components/Desktop/ButtonTabs'

const TabsWl = () => {
  const { workListStore, workListStoreFunc } = useWorkListStoreManager()
  const { selectedTab } = workListStore
  const { changeTab } = workListStoreFunc

  return (
    <ButtonTabsContainer>
      {AllStatusesDeal.map((item, i) => {
        return (
          <ButtonTab
            key={i}
            isActive={selectedTab === item.code}
            onClick={() => changeTab(item.code)}
          >
            {item.name}
          </ButtonTab>
        )
      })}
    </ButtonTabsContainer>
  )
}

export default TabsWl
